import { render, staticRenderFns } from "./MessageBrand.vue?vue&type=template&id=26e666fe"
import script from "./MessageBrand.vue?vue&type=script&lang=js"
export * from "./MessageBrand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports